import styled from '@emotion/styled'
import React from 'react'

import { Card } from 'packages/common'
import { IconName, SvgIcon } from 'packages/iconic'
import { colors } from 'packages/styles'

import { gwColors } from 'app/styles'

const St = {
  Divider: styled.hr`
    border-color: ${gwColors.uiDivider};
    margin: 0;

    &:last-child {
      display: none;
    }
  `,
  Link: styled.a`
    color: ${colors.lake};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin: 12px 0;

    &:focus {
      outline: 1px solid ${colors.midnight30};
    }

    &:first-of-type {
      margin-top: 0;
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    // blanket selector to ensure all child elements are Flex containers
    span {
      display: flex;
    }
  `,
  LinksCard: styled(Card)`
    padding: 16px;
  `,
}

type LinkProps = {
  text: string
  url: string
}

const Link = ({ text, url }) => (
  <>
    <St.Link
      aria-label={text}
      href={url}
      rel="noopener noreferrer"
      target="_blank"
    >
      <span>{text}</span>
      <span>
        <SvgIcon centerItems={true} icon={IconName.externalLink} size={16} />
      </span>
    </St.Link>
    <St.Divider />
  </>
)

type LinksCardProps = {
  className?: string
  links: LinkProps[]
}

export const LinksCard: React.FC<LinksCardProps> = React.memo(
  ({ className, links }) => (
    <St.LinksCard className={className}>
      {links.map(({ text, url }) => (
        <Link key={text} text={text} url={url} />
      ))}
    </St.LinksCard>
  ),
)
